<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Badge" });
import "tailwindcss/tailwind.css";
import Tooltip from "../tooltip/Tooltip.svelte";
import { t } from "svelte-i18n";
export let label = "";
export let description = "";
export let size = "sm";
export let css = "";
export let color = "quaternary";
export let style = "subtle";
let isTooltipVisible = false;
const toggleTooltipVisibility = () => {
    isTooltipVisible = !isTooltipVisible;
};
</script>

{#if label !== undefined }
    <span
        on:mouseenter = { toggleTooltipVisibility }
        on:mouseleave = { toggleTooltipVisibility }
        on:click = { toggleTooltipVisibility }
        on:keypress = { toggleTooltipVisibility }
        class = { `s8-badge s8-${ size } ${ css } s8-${ color } s8-${ style }` }
        class:s8-has-description = { Boolean(description) }
    >
        <slot>{ $t(label) }</slot>

        {#if description !== ''}
            <Tooltip position = 'south' isVisible = { isTooltipVisible } css = 'mb-2'>
                { description }
            </Tooltip>
        {/if}
    </span>
{/if}

<style>

    span.s8-badge {
        white-space: pre;
        display: inline-block;
        border-radius: 2px;
        padding: 0px 4px;
        vertical-align: middle;
        border: 1px solid transparent;
        position: relative;
        top: -1px;
        text-align: center;
    }

        span.s8-badge.s8-xs {
            font-size: 7px;
            line-height: 10px;
        }

        span.s8-badge.s8-sm {
            font-size: 9px;
            line-height: 15px;
        }

        span.s8-badge.s8-md {
            font-size: 11px;
            line-height: 16px;
        }

        span.s8-badge.s8-lg {
            font-size: 12px;
            line-height: 20px;
        }

        span.s8-badge.s8-subtle.s8-dark {
        border-width: 1px;
        border-color: rgba(231, 231, 230, 1);
        background-color: rgba(231, 231, 230, 1);
        color: rgba(151, 150, 145, 1);
}

        span.s8-badge.s8-subtle.s8-primary {
        border-width: 1px;
        border-color: rgba(161, 193, 175, 1);
        background-color: rgba(161, 193, 175, 1);
        color: rgba(68, 131, 95, 1);
}

        span.s8-badge.s8-subtle.s8-secondary {
        border-width: 1px;
        border-color: rgba(247, 224, 218, 1);
        background-color: rgba(247, 224, 218, 1);
        color: rgba(230, 152, 131, 1);
}

        span.s8-badge.s8-subtle.s8-tertiary {
        border-width: 1px;
        border-color: rgba(219, 243, 246, 1);
        background-color: rgba(219, 243, 246, 1);
        color: rgba(82, 189, 203, 1);
}

        span.s8-badge.s8-subtle.s8-quaternary {
        border-width: 1px;
        border-color: rgba(243, 241, 248, 1);
        background-color: rgba(243, 241, 248, 1);
        color: rgba(136, 121, 185, 1);
}

        span.s8-badge.s8-subtle.s8-quinary {
        border-width: 1px;
        border-color: rgba(237, 232, 237, 1);
        background-color: rgba(237, 232, 237, 1);
        color: rgba(183, 164, 183, 1);
}

        span.s8-badge.s8-subtle.s8-danger {
        border-width: 1px;
        border-color: rgba(237, 173, 181, 1);
        background-color: rgba(237, 173, 181, 1);
        color: rgba(239, 35, 59, 1);
}

        span.s8-badge.s8-subtle.s8-warning {
        border-width: 1px;
        border-color: rgba(253, 243, 216, 1);
        background-color: rgba(253, 243, 216, 1);
        color: rgba(245, 192, 32, 1);
}

        span.s8-badge.s8-outline.s8-dark {
        border-width: 1px;
        border-color: rgba(39, 39, 17, 1);
        color: rgba(39, 39, 17, 1);
}

        span.s8-badge.s8-outline.s8-grey {
        border-width: 1px;
        border-color: rgba(193, 192, 189, 1);
        color: rgba(193, 192, 189, 1);
}

        span.s8-badge.s8-outline.s8-primary {
        border-width: 1px;
        border-color: rgba(68, 131, 95, 1);
        color: rgba(68, 131, 95, 1);
}

        span.s8-badge.s8-outline.s8-secondary {
        border-width: 1px;
        border-color: rgba(230, 152, 131, 1);
        color: rgba(230, 152, 131, 1);
}

        span.s8-badge.s8-outline.s8-tertiary {
        border-width: 1px;
        border-color: rgba(82, 189, 203, 1);
        color: rgba(82, 189, 203, 1);
}

        span.s8-badge.s8-outline.s8-quaternary {
        border-width: 1px;
        border-color: rgba(136, 121, 185, 1);
        color: rgba(136, 121, 185, 1);
}

        span.s8-badge.s8-outline.s8-quinary {
        border-width: 1px;
        border-color: rgba(183, 164, 183, 1);
        color: rgba(183, 164, 183, 1);
}

        span.s8-badge.s8-outline.s8-danger {
        border-width: 1px;
        border-color: rgba(239, 35, 59, 1);
        color: rgba(239, 35, 59, 1);
}

        span.s8-badge.s8-outline.s8-warning {
        border-width: 1px;
        border-color: rgba(245, 192, 32, 1);
        color: rgba(245, 192, 32, 1);
}

        span.s8-badge.s8-strong { color: #ffffff; }

        span.s8-badge.s8-strong.s8-dark {
        border-width: 1px;
        border-color: rgba(39, 39, 17, 1);
        background-color: rgba(39, 39, 17, 1);
}

        span.s8-badge.s8-strong.s8-primary {
        border-width: 1px;
        border-color: rgba(68, 131, 95, 1);
        background-color: rgba(68, 131, 95, 1);
}

        span.s8-badge.s8-strong.s8-secondary {
        border-width: 1px;
        border-color: rgba(230, 152, 131, 1);
        background-color: rgba(230, 152, 131, 1);
}

        span.s8-badge.s8-strong.s8-tertiary {
        border-width: 1px;
        border-color: rgba(82, 189, 203, 1);
        background-color: rgba(82, 189, 203, 1);
}

        span.s8-badge.s8-strong.s8-quaternary {
        border-width: 1px;
        border-color: rgba(136, 121, 185, 1);
        background-color: rgba(136, 121, 185, 1);
}

        span.s8-badge.s8-strong.s8-quinary {
        border-width: 1px;
        border-color: rgba(183, 164, 183, 1);
        background-color: rgba(183, 164, 183, 1);
}

        span.s8-badge.s8-strong.s8-danger {
        border-width: 1px;
        border-color: rgba(239, 35, 59, 1);
        background-color: rgba(239, 35, 59, 1);
}

        span.s8-badge.s8-strong.s8-warning {
        border-width: 1px;
        border-color: rgba(245, 192, 32, 1);
        background-color: rgba(245, 192, 32, 1);
}

        span.s8-badge.s8-has-description {
        cursor: pointer;
}</style>